/* unplugin-vue-components disabled */import { render } from "./BindNodeComponent.vue?vue&type=template&id=5a73ab84&scoped=true"
import script from "./BindNodeComponent.vue?vue&type=script&lang=js"
export * from "./BindNodeComponent.vue?vue&type=script&lang=js"

import "./BindNodeComponent.vue?vue&type=style&index=0&id=5a73ab84&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a73ab84"]])

export default __exports__